const theme = {
  font: {
    primary: `'Georgia', serif`,
    secondary: `'Georgia', serif`,
  },
  font_size: {
    xsmall: 'font-size: 20px; line-height: 12px',
    small: 'font-size: 20px; line-height: 30px',
    regular: 'font-size: 24px; line-height: 32px',
    large: 'font-size: 30px; line-height: 40px',
    larger: 'font-size: 36px; line-height: 48px',
    xlarge: 'font-size: 48px; line-height: 52px',
  },
  color: {
    white: {
      regular: '#FFFFFF',
      dark: '#F6F6F6',
    },
    black: {
      lighter: '#ABA8AF',
      light: '#2a2730',
      regular: '#211E26',
    },
    primary: '#0096C8',
    secondary: '#0096C8',
  },
  screen: {
    xs: '575px',
    sm: '767px',
    md: '991px',
    lg: '1199px',
  },
};

export default theme;
